/* Variant image carousel for product cards (see snippets/card-variant-carousel.liquid) */
if (!customElements.get('card-variant-carousel')) {
  class CardVariantCarousel extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.track = this.querySelector('.cvc__track');
      if (!this.track) return;
      this.slides = Array.from(this.track.querySelectorAll('.cvc__slide'));
      this.dots = Array.from(this.querySelectorAll('.cvc__dot'));
      this.index = 0;
      this.target = null;

      const wrapper = this.closest('.card-wrapper');
      if (wrapper) {
        this.variantEl = wrapper.querySelector('[data-cvc-variant]');
        this.priceEl = wrapper.querySelector('[data-cvc-price]');
        this.titleLink = wrapper.querySelector('.card > .card__content .card__heading a');
        this.badgeEl = wrapper.querySelector('[data-cvc-badge]');
      }

      const prev = this.querySelector('.cvc__arrow--prev');
      const next = this.querySelector('.cvc__arrow--next');
      if (prev) prev.addEventListener('click', (event) => this.onArrow(event, -1));
      if (next) next.addEventListener('click', (event) => this.onArrow(event, 1));

      this.track.addEventListener(
        'scroll',
        () => {
          cancelAnimationFrame(this._raf);
          this._raf = requestAnimationFrame(() => this.sync());
        },
        { passive: true }
      );

      this.track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.onArrow(event, -1);
        if (event.key === 'ArrowRight') this.onArrow(event, 1);
      });

      if (this.slides.length) this.updateBadge(this.slides[0]);
    }

    onArrow(event, step) {
      event.preventDefault();
      event.stopPropagation();
      /* Count from the slide we're already heading to, so quick repeated clicks keep advancing */
      const from = this.target !== null ? this.target : this.index;
      this.go(from + step);
    }

    go(targetIndex) {
      const count = this.slides.length;
      if (!count) return;
      const i = ((targetIndex % count) + count) % count;
      this.target = i;
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' });
    }

    /* 'Only N Left!' sticker follows the option on display: shown for 1-9 copies, hidden otherwise */
    updateBadge(slide) {
      if (!this.badgeEl || !slide) return;
      const stock = parseInt(slide.dataset.stock, 10);
      if (stock > 0 && stock < 10) {
        this.badgeEl.textContent = 'Only ' + stock + ' Left!';
        this.badgeEl.style.display = '';
      } else {
        this.badgeEl.style.display = 'none';
      }
    }

    sync() {
      const width = this.track.clientWidth || 1;
      const i = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / width)));
      if (this.target !== null && Math.abs(this.track.scrollLeft - this.target * width) < 2) this.target = null;
      if (i === this.index) return;
      this.index = i;

      this.dots.forEach((dot, k) => dot.classList.toggle('is-active', k === i));
      this.slides.forEach((slide, k) => {
        if (k === i) slide.removeAttribute('tabindex');
        else slide.setAttribute('tabindex', '-1');
      });

      const slide = this.slides[i];
      if (this.variantEl) this.variantEl.textContent = slide.dataset.title;
      if (this.priceEl) this.priceEl.textContent = slide.dataset.price;
      if (this.titleLink) this.titleLink.setAttribute('href', slide.getAttribute('href'));
      this.updateBadge(slide);
    }
  }

  customElements.define('card-variant-carousel', CardVariantCarousel);
}
